<template>
    <v-dialog
        content-class="motivationInfoWrapper"
        :value="dialog"
        persistent
        transition="dialog-bottom-transition"
        width="1260"
    >
        <div class="motivationInfo">
            <div class="motivationInfo_header">
                <span class="motivationInfo_header-title">Trucks for <span class="gr">{{ currentDataInfo.currentDate | dateFormat }}</span></span>
                <button type="button" @click="closeDialog">
                    <svg-sprite width="20" height="20" icon-id="close"></svg-sprite>
                </button>
            </div>
            <div class="motivationInfo_body">
                <info
                    v-if="motivationProgramInfo"
                    :statisticsInfo="motivationProgramInfo"
                    title="Motivation"
                ></info>
                <info-table
                    v-if="motivationProgramFilter"
                    :filter="motivationProgramFilter"
                    :list-items="motivationProgramList"
                    :currentDataInfo="currentDataInfo"
                ></info-table>
            </div>
        </div>
    </v-dialog>
</template>

<script>
import { mapGetters } from "vuex";
// components
import InfoTable from "@/components/Fleet/WorkOrdersStatistics/MotivationProgram/MotivationInfo/InfoTable/InfoTable";
import Info from "@/components/Fleet/WorkOrdersStatistics/Info/Info";

export default {
	name: "StatisticsInfo",
	components: {
		InfoTable,
		Info
	},
	props: {
		currentDataInfo: Object
	},
	computed: mapGetters([ 'motivationProgramInfo', 'motivationProgramList', 'motivationProgramFilter' ]),
	data: () => ({
		dialog: true
	}),
	methods: {
		closeDialog() {
			this.$emit('updateClose');
		}
	}
};
</script>

<style scoped lang="scss">
@import "motivationInfo";
</style>
